import React from 'react'

import * as s from './LayoutSidebar.module.scss'

const LayoutSidebar: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={s.root}>{children}</div>
)

export default LayoutSidebar
